import { useAnalytics } from '@app/features/analytics/hooks/use-analytics';
import React from 'react';

import { BranchIcon } from '../../icons/branch-icon';
import { BranchStartIcon } from '../../icons/branch-start-icon';
import { navigateToEvent } from '../../utils';
import { EventType } from '../events/types';

export const EventNameTemplate = ({
  data,
  rowIndex,
}: {
  data: EventType;
  rowIndex: number;
}) => {
  const { track } = useAnalytics();

  return (
    <div className="flex items-center min-h-[40px] ml-7 relative overflow-visible w-full">
      <div
        className={`absolute left-[-6px] z-[10] ${
          rowIndex === 0 ? 'top-[-8px]' : 'top-[-58px]'
        }`}
        style={{ pointerEvents: 'none' }}
      >
        {rowIndex === 0 ? <BranchStartIcon /> : <BranchIcon />}
      </div>

      <div className="flex items-center pl-2 min-w-0 flex-1 overflow-hidden">
        <img
          className="rounded-md h-[32px] w-14 min-w-14 mr-4 flex-shrink-0"
          src={data.eventBannerUrl}
          alt=""
        />

        <button
          className="my-auto min-w-0 flex-1"
          onClick={() => {
            navigateToEvent(data.slug);
            track('ola_series_tab_individual_event_click', {
              eventSlug: data.slug,
              eventName: data.name,
            });
          }}
        >
          <span
            title={data.name}
            className="font-inter font-medium text-sm truncate block text-left"
          >
            {data.name}
          </span>
        </button>
      </div>
    </div>
  );
};
